import ToastStatusEnum from "constants/ToastStatusEnum";
import { Form, Formik } from "formik";
import IStore from "models/IStore";
import React, { Fragment, useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Dispatch } from "redux";
import { selectRequesting } from "selectors/requesting/RequestingSelector";
import * as AuthAction from "stores/auth/AuthAction";
import * as ToastAction from "stores/toasts/ToastsAction";
import TextField from "views/components/textfield/TextField";
import * as Yup from "yup";
import { dispatchAction } from "utilities/DispatchUtility";

const validationSchema = (t: Function) => {
  return Yup.object().shape({
    email: Yup.string().required(t("general.email-required")).email(t("general.email-email")),
  });
};

interface IProps {
  readonly mouseLeave: (e: any) => void;
}

const InviteMember: React.FC<IProps> = (props: IProps) => {
  const { t } = useTranslation();
  const dispatch: Dispatch = useDispatch();

  const { mouseLeave } = props;

  const [isVisibleModal, setVisibleModal] = useState<boolean>(false);

  const handleCloseModal = () => {
    setVisibleModal(false);
  };

  const handleOpenModal = (e: any) => {
    setVisibleModal(true);
    mouseLeave(e);
  };

  const isRequesting: boolean = useSelector((state: IStore) =>
    selectRequesting(state, [AuthAction.REQUEST_INVITE_MEMBER]),
  );

  const inviteMemberMessage: string | undefined = useSelector((state: IStore) => state.auth.inviteMemberMessage);

  useEffect(() => {
    if (inviteMemberMessage === "success") {
      dispatchAction(dispatch, ToastAction.add(t("invitation-member.success-message"), ToastStatusEnum.Success));
      dispatchAction(dispatch, AuthAction.clearRequestInviteMemberMessage());
      handleCloseModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inviteMemberMessage]);

  return (
    <Fragment>
      <Link to={"#"} onClick={handleOpenModal}>
        {t("invitation-member.button")}
      </Link>

      <Modal show={isVisibleModal} onHide={handleCloseModal} dialogClassName="modal-width">
        <Modal.Header closeButton>
          <Modal.Title>{t("invitation-member.title")}</Modal.Title>
        </Modal.Header>
        <Formik
          validationSchema={validationSchema(t)}
          initialValues={{ email: "" }}
          onSubmit={(formValue: any) => {
            dispatch(AuthAction.requestInviteMember(formValue));
          }}
        >
          {() => {
            return (
              <Form>
                <Modal.Body>
                  <TextField label={t("general.email")} name="email" type="email" />
                </Modal.Body>
                <Modal.Footer>
                  <Button className="btn cs-button-reset" disabled={isRequesting} onClick={handleCloseModal}>
                    {t("buttons.close")}
                  </Button>
                  <Button className="btn cs-button-action" disabled={isRequesting} type="submit">
                    {t("invitation-member.button")}
                  </Button>
                </Modal.Footer>
              </Form>
            );
          }}
        </Formik>
      </Modal>
    </Fragment>
  );
};

export default InviteMember;
